"use strict";
// (C) 2007-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAttributeFilterPlaceholder = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
function AddAttributeFilterPlaceholder(_a) {
    var disabled = _a.disabled;
    var className = classnames_1.default("add-item-placeholder", "add-attribute-filter-placeholder", "s-add-attribute-filter", {
        disabled: disabled,
    });
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "addPanel.attributeFilter" })));
}
exports.AddAttributeFilterPlaceholder = AddAttributeFilterPlaceholder;
//# sourceMappingURL=AddAttributeFilterPlaceholder.js.map